var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    fontFamily: _vm.globalFont
  })},[_vm._v("\n  "+_vm._s(_vm.error_message)),_c('br'),_vm._v(" "),(_vm.error_code && _vm.error_message !== '')?_c('div',{staticClass:"error-code-container"},[_vm._v("\n    [ERROR "+_vm._s(_vm.error_code)+"]\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49217958","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/KpaymentMessages.vue
// module id = null
// module chunks = 